export function H2(props) {
  return (
    <h2 className="pd-panel__header--h2" id={props.id}>
      {props.children}
    </h2>
  );
}

export default H2;
